import React, { Component } from 'react';

class TextInput extends Component {
  render () {
    const { id, type, classNames, hascontainer, title, ...others } = this.props;
    let classes = classNames;
    if (!classNames) classes = '';

    let t_type = type;
    if (!t_type) t_type = 'text';

    let jsx = <input type={t_type} {...others} id={id} name={id} className={`${classes} form-control`} />;

    // if TextInput has enclosing container
    if (hascontainer) {
      jsx = (
        <div className="md-form">
          <label for={id}>{title}</label>
          <input {...others} type={t_type} id={id} name={id} className={`${classes} form-control`} />
        </div>
      );
    }

    return jsx;
  }
};

export default TextInput;
